import { Component } from '@angular/core';
import { SettingsService } from './services/settings.service';
import {  Router } from '@angular/router';




@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'vinolabNg';
  public loading = false;
  constructor(private settingService: SettingsService, private router: Router) {
    // console.log(this.router.url);
    // if (this.router.url !== '/') {
    //   this.loading = true;
    //   this.loginService.checkAuth().subscribe(resp => {
    //     this.loading = false;
    //     if (resp == 'token_invalid' || resp == 'token_expired') {
    //       localStorage.removeItem('token');
    //       this.router.navigate(['/']);
    //     }
    //   });
    // }

    // this.getIps();
  }


  getIps() {
    this.settingService.checkIp().subscribe(mainData => {
      if (mainData && mainData == 402) {
        this.router.navigate(['/']);
      }
    });
  }


}
